// Upload compression presets, shared by utils/imageUtils.js (app) and
// web/src/lib/files.js (web) so both send the same sizes to Storage.
export const IMAGE_PRESETS = {
  upload: { maxWidth: 1200, quality: 0.6 }, // chat images, club gallery
  event: { maxWidth: 600, quality: 0.4 }, // event card images
  avatar: { maxWidth: 600, quality: 0.6 }, // avatars, club logos
};
